import React from 'react';
import './contacts.scss';

const Contacts = () => {
  return (
    <div>Contacts</div>
  )
}

export default Contacts